const socialMediaLinks = [
  "https://github.com/nadialvy",
  "mailto:nadialovely1803@gmail.com",
  "https://www.instagram.com/nadlvy_",
  "https://www.linkedin.com/in/nadia-lovely",
  "https://medium.com/@daisythoughts",
  "https://drive.google.com/file/d/1PbbT4J18Y_tadeQpqiCKi2fR0oZgGXGB/view?usp=sharing",
  "https://github.com/nadialvy",
  "mailto:nadialovely1803@gmail.com",
  "https://www.instagram.com/nadlvy_",
  "https://www.linkedin.com/in/nadia-lovely",
  "https://medium.com/@daisythoughts",
  "https://drive.google.com/file/d/1PbbT4J18Y_tadeQpqiCKi2fR0oZgGXGB/view?usp=sharing",
];

export default socialMediaLinks;